import React from 'react';

import {getContentType} from 'sweet-helpers';

import {SUPPORT_APPROVAL_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import {DocumentAlertBox} from './DocumentAlertBox';

import type {DocumentContentType} from 'sweet-types';

export const getApprovalArticleLink = () => (
  <a
    rel="noopener noreferrer"
    className="alert-link"
    target="_blank"
    href={SUPPORT_APPROVAL_URL}
  >
    {gt('article')}
  </a>
);

type Props = {
  contentType: DocumentContentType;
};

export const NoApprovedVersionsAlertBox = ({contentType}: Props) => {
  const ct = getContentType(contentType, gt).name;

  const article = getApprovalArticleLink();

  return (
    <DocumentAlertBox
      type="warning"
      icon="fa-exclamation-triangle"
      title={gt('Draft only')}
      content={
        <div>
          {gt(
            'This %s is a draft and has not been approved for official use.',
            ct
          )}
          <p className="font-weight-bold mt-2">
            {gt('Urgent action required:')}
          </p>
          <ul>
            <li>
              {gt(
                'For managers: Please review the pending drafts in the version history above and approve a suitable draft for implementation.'
              )}{' '}
              <i className="far fa-clock" />
            </li>
            <li>
              {gt(
                'Non-managers: Be aware that this document is not yet finalized and should not be used as an official reference.',
                ct
              )}
            </li>
          </ul>
          <p>
            <strong>{gt('Help:')}</strong>{' '}
            {gt(
              'A guide about approving a %(ct)s is available in our knowledge base %(article)s',
              {
                article,
                ct,
              }
            )}
          </p>
        </div>
      }
    />
  );
};

export const showNoApprovedVersionsAlertBoxIfNotApproved = (
  contentType: DocumentContentType,
  approved_at?: string | null
) =>
  approved_at != null ? null : (
    <NoApprovedVersionsAlertBox contentType={contentType} />
  );
